import { handleActions } from '@gef-ui/utils/fsaActions';
import always from "ramda/es/always";
import append from "ramda/es/append";
import assoc from "ramda/es/assoc";
import evolve from "ramda/es/evolve";
import o from "ramda/es/o";
import omit from "ramda/es/omit";
import uniq from "ramda/es/uniq";
import without from "ramda/es/without";
import isArray from "ramda-extension/es/isArray";
import { actionTypes } from '../constants';
export const defaultState = {
    statuses: {},
    requestUuids: []
};
const setRequestStatus = (state, { payload })=>evolve({
        statuses: assoc(payload.requestUuid, payload.status),
        requestUuids: o(uniq, append(payload.requestUuid))
    })(state);
const clearRequestStatus = (state, { payload })=>{
    const statusKeysToOmit = isArray(payload) ? payload : [
        payload
    ];
    return evolve({
        statuses: omit(statusKeysToOmit),
        requestUuids: without(statusKeysToOmit)
    })(state);
};
export default handleActions({
    [actionTypes.SET_REQUEST_STATUS]: setRequestStatus,
    [actionTypes.CLEAR_REQUEST_STATUS]: clearRequestStatus,
    [actionTypes.RESET]: always(defaultState)
}, defaultState);
